export enum EUserConfiguracionAntifraudeEstado {
  Exento = 1,
  Verifactu,
}
